import { Component, Inject, OnInit } from '@angular/core';
import { RmsModule } from '@rms';
import { RmsPulldownRef } from '../../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown-ref';
import { RMS_PULLDOWN_DATA } from '../../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown.tokens';
import { CustomerCrmService } from '@services';

@Component({
  selector: 'app-sample-request-form',
  imports: [RmsModule],
  templateUrl: './sample-request-form.component.html',
  styleUrl: './sample-request-form.component.scss'
})
export class SampleRequestFormComponent implements OnInit {
  Sample: any = {};
  InventoryTypes: any[] = [];

  constructor(@Inject(RMS_PULLDOWN_DATA) private data: any, public ref: RmsPulldownRef, private crm: CustomerCrmService) {
    this.Sample = { ...data };
  }

  ngOnInit() {
    this.crm.getInventoryTypes().subscribe({
      next: (types) => this.InventoryTypes = types || []
    });
  }

  save() {
    this.ref.close({ ...this.Sample, cancelled: false });
  }

  cancel() {
    this.ref.close({ cancelled: true });
  }
}
